module.exports = __webpack_public_path__ + "static/img/1_1_4_1.2233cac6.jpg";